/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    document.querySelectorAll(".prdgalleyMute, .glb_mute, .mutedButton").forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentDiv = btn.parentElement; // find nearest parent div
      const currentVideo = parentDiv.querySelector("video");
      if (currentVideo && !currentVideo.paused) {
        document.querySelectorAll(".banner_video_wrapper").forEach((wrapper) => {
          const video = wrapper.querySelector("video");
          const playBtn = wrapper.querySelector('.glb_play');
          const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
          if (video !== currentVideo && !video.paused) {
            video.muted = true;
            const parentDivELe = video.parentElement;
            const muteBtn = parentDivELe.querySelector(
              ".prdgalleyMute, .glb_mute, .mutedButton"
            );
            if (muteBtn) {
              muteBtn.classList.add("muted");
            }
          }
          else{
            console.log("outt...")
          }
        });
      }
    });
  });
  function offsoundAllVideos( trigger = null ) {
    let posterWrapper = '';
    console.log("call the video pause",trigger)
    const isMobile = window.innerWidth <= 767;

    const allOtherVideos = document.querySelectorAll('.banner_video_wrapper');
    allOtherVideos.forEach((wrapper) => {
      const video = wrapper.querySelector("video");
      const playBtn = wrapper.querySelector('.glb_play');
      posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      video.muted = true;
      video.pause();
      playBtn?.classList.remove('playing');
      if (posterWrapper) posterWrapper.style.opacity = 1;
      const parentDiv = video.parentElement;
      // find any button matching one of these classes
      const muteBtn = parentDiv.querySelector(
        ".prdgalleyMute, .glb_mute, .mutedButton"
      );
      if (muteBtn) {
        muteBtn.classList.add("muted");
      }
    });




    const videoWrappers = document.querySelectorAll('.banner_video_wrapper');
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');

      

      const muteBtn = wrapper.querySelector('.glb_mute');
      const playBtn = wrapper.querySelector('.glb_play');
      posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      if( shouldAutoplay() )
      {
        if (video) {
          video.muted = true;
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
      }
      else{
        video.pause();
        playBtn?.classList.remove('playing');
        if (posterWrapper) posterWrapper.style.opacity = 1;
      }
    });
    

  }
  document.addEventListener('click', function handler() {
    document.body.classList.add('clicked-anywhere');
    document.removeEventListener('click', handler);
  });
  function initCustomVideoPlayerWithHLS(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.banner_video_wrapper');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

            


      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
              console.log("jj...")

        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              // Sound must only be enabled by an explicit click on this video's sound control.
              if (video.dataset.userSoundEnabled !== 'true') {
                video.muted = true;
                muteBtn?.classList.add('muted');
              }
              playBtn?.classList.add('playing');
              
            })
            .catch(() => {
              playBtn?.classList.remove('playing');
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if( autoplay && video )
        {
          //video.muted = true;
          // if (muteBtn) {
          //   muteBtn.classList.add('muted');
          // }
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.banner_video_wrapper');
          if (!wrap) return;
          //const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          const shouldPlay = isVisible(entry, wrap);
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos('trigger');
          safePlay();
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
          pauseVideo();
        }
      });

      if (muteBtn) {
        //muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        const updateSoundControl = () => {
          const isMuted = video.muted;
          muteBtn.classList.toggle('muted', isMuted);
          muteBtn.setAttribute('aria-pressed', String(!isMuted));
          muteBtn.setAttribute('aria-label', isMuted ? 'Sl\u00e5 lyd til' : 'Sl\u00e5 lyd fra');
          muteBtn.textContent = isMuted ? '\uD83D\uDD0A Sl\u00e5 lyd til' : '\uD83D\uDD07 Sl\u00e5 lyd fra';
        };
        updateSoundControl();
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          video.dataset.userSoundEnabled = String(!video.muted);
          updateSoundControl();
        });
        muteBtn.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            muteBtn.click();
          }
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  function ____initCustomVideoPlayerWithHLS(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.banner_video_wrapper');
    const isMobile = window.innerWidth <= 767;

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
        videoWrappers.forEach((wrapper) => {
          const videojj = wrapper.querySelector('video');
          pauseVideo( videojj, wrapper );
        })
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              playBtn?.classList.add('playing');
              // Don't hide poster yet — wait for "playing" event
            })
            .catch(() => {
              playBtn?.classList.remove('playing');
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if (video.closest('.ppblock')?.classList.contains('is-selected')) {
            autoplay = videoAutoplay ? true : false;
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } else if (window.Hls && Hls.isSupported()) {
            hls = new Hls({ maxBufferLength: 3 });
            hls.loadSource(src);
            hls.attachMedia(video);
            video.hlsInstance = hls;

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
              isVideoLoaded = true;
              if (autoplay) safePlay();
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.banner_video_wrapper');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          safePlay();
        } else {
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        const updateSoundControl = () => {
          const isMuted = video.muted;
          muteBtn.classList.toggle('muted', isMuted);
          muteBtn.setAttribute('aria-pressed', String(!isMuted));
          muteBtn.setAttribute('aria-label', isMuted ? 'Sl\u00e5 lyd til' : 'Sl\u00e5 lyd fra');
          muteBtn.textContent = isMuted ? '\uD83D\uDD0A Sl\u00e5 lyd til' : '\uD83D\uDD07 Sl\u00e5 lyd fra';
        };
        updateSoundControl();
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          video.dataset.userSoundEnabled = String(!video.muted);
          updateSoundControl();
        });
        muteBtn.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            muteBtn.click();
          }
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

function initCustomFeaturedProductSlider(root = document) {
  const sections = root.querySelectorAll('.media-testimonials');

  sections.forEach((section) => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
    const grid = section.querySelector(".custom-products-grid");
    if (!grid) return;

    const isMobile = window.innerWidth <= 768;
    const slidesDesktop = parseInt(section.dataset.slidesDesktop || 4);
    const slidesTablet = parseInt(section.dataset.slidesTablet || 3);
    const slidesMobile = parseInt(section.dataset.slidesMobile || 1);
    let autoplay = section.dataset.autoplay === "true";
    let autoplayInterval = parseInt(section.dataset.autoplayInterval || 5000);
    let controlls = section.dataset.controlls === "true";
    const autoplayMobile = section.dataset.autoplayMobile === "true";
    const autoplayIntervalMobile = parseInt(section.dataset.autoplayIntervalMobile || 5000);
    const controllsMobile = section.dataset.controllsMobile === "true";

    if (grid.flickityInstance) {
      grid.flickityInstance.destroy();
      grid.flickityInstance = null;
    }

    let slidesToShow = slidesMobile;
    const width = window.innerWidth;
    if (width > 1100) slidesToShow = slidesDesktop;
    else if (width > 767) slidesToShow = slidesTablet;
    const blocks = section.querySelectorAll(".ppblock");
    blocks.forEach((block) => {
      block.style.width = `${100 / slidesToShow}%`;
      block.style.boxSizing = "border-box";
    });
    let alignCells = 'left';
    autoplay = isMobile ? autoplayMobile : autoplay;
    autoplayInterval = isMobile ? autoplayIntervalMobile : autoplayInterval;
    controlls = isMobile ? controllsMobile : controlls;
    const wrapAround = blocks.length > slidesToShow;
    let contain = false;
    if( wrapAround == false ){
      controlls = false;
      contain = true;
    }

        console.log("...slidesToShow",slidesToShow, contain)

    const flkty = new window.theme.Flickity(grid, {
      cellAlign: alignCells,
      contain: contain,
      wrapAround: wrapAround,
      pauseAutoPlayOnHover: false,
      prevNextButtons: controlls,
      pageDots: false,
      autoPlay: autoplay ? autoplayInterval : false,
      draggable: true,
    });
    

    grid.flickityInstance = flkty;
    section.querySelector('.flickity-prev').addEventListener('click', function () {
      flkty.previous();
    });
    section.querySelector('.flickity-next').addEventListener('click', function () {
      flkty.next();
    });
    const counterEl = section.querySelector('.custom-products-counter');
    counterEl.style.display = "none";
    function updateUI(index) {
      const current = (index % blocks.length) + 1;
    }
    const videoAutoplay = section.dataset.videoAutoplay === "true";
    if( videoAutoplay )
    {
      flkty.on('ready', function () {
        const selectedElem = flkty.selectedElement;
        if (!selectedElem) return;

        const videoWrap = selectedElem.querySelector('.banner_video_wrapper');
        if (videoWrap) {
          const video = videoWrap.querySelector('video');
          if (video) {
            const playBtn = videoWrap.querySelector('.glb_play');
            if (playBtn) {
              playBtn.classList.add('playing');
            }
            video.play().catch(() => {});
          }
        }
        // Pause all other videos in non-selected slides
        flkty.cells.forEach(cell => {
          const el = cell.element;
          if (el !== selectedElem) {
            const otherWrap = el.querySelector('.banner_video_wrapper');
            if (otherWrap) {
              const otherVideo = otherWrap.querySelector('video');
              if (otherVideo && !otherVideo.paused) {
                otherVideo.pause();

                const playBtn = otherWrap.querySelector('.glb_play');
                if (playBtn) {
                  playBtn.classList.remove('playing');
                }
              }
            }
          }
        });

        updateUI(flkty.selectedIndex);
      });
      flkty.on('select', function () {
        const selectedElem = flkty.selectedElement;
        if (!selectedElem) return;

        const videoWrap = selectedElem.querySelector('.banner_video_wrapper');
        if (videoWrap) {
          const video = videoWrap.querySelector('video');
          if (video) {
            const playBtn = videoWrap.querySelector('.glb_play');
            if (playBtn) {
              playBtn.classList.add('playing');
            }
            video.play().catch(() => {});
          }
        }

        // Pause all other videos in non-selected slides
        flkty.cells.forEach(cell => {
          const el = cell.element;
          if (el !== selectedElem) {
            const otherWrap = el.querySelector('.banner_video_wrapper');
            if (otherWrap) {
              const otherVideo = otherWrap.querySelector('video');
              if (otherVideo && !otherVideo.paused) {
                otherVideo.pause();

                const playBtn = otherWrap.querySelector('.glb_play');
                if (playBtn) {
                  playBtn.classList.remove('playing');
                }
              }
            }
          }
        });

        updateUI(flkty.selectedIndex);
      });
    }


  });
}

let lastWindowWidth = window.innerWidth;

function debounce(fn, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  };
}

// init on load

window.addEventListener('resize', debounce(() => {
  const currentWidth = window.innerWidth;
  if (currentWidth !== lastWindowWidth) {
    lastWindowWidth = currentWidth;
    initCustomFeaturedProductSlider(); // only run when width changed
  }
}, 200));




// Init on load and Shopify events
document.addEventListener("DOMContentLoaded", () => initCustomFeaturedProductSlider());
document.addEventListener("shopify:load", () => initCustomFeaturedProductSlider());
document.addEventListener("shopify:section:load", (e) => initCustomFeaturedProductSlider(e.target));
document.addEventListener("shopify:section:select", (e) => initCustomFeaturedProductSlider(e.target));

function initSingleVideoWithHls(root = document) {
  const sections = root.querySelectorAll('.custom-video-section');

  sections.forEach((section) => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
  });
}

document.addEventListener("DOMContentLoaded", () => initSingleVideoWithHls());
document.addEventListener("shopify:load", () => initSingleVideoWithHls());
document.addEventListener("shopify:section:load", (e) => initSingleVideoWithHls(e.target));
document.addEventListener("shopify:section:select", (e) => initSingleVideoWithHls(e.target));

  
  function initFlickitySlider(root = document) {
    root.querySelectorAll('.compare-product-model .flickity-slider-main').forEach(slider => {
      if (slider.dataset.flickityInit) return; // prevent double init
      slider.dataset.flickityInit = 'true';

      var flkty = new window.theme.Flickity(slider, {
        cellAlign: 'left',
        contain: false,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true
      });

      var productInfo = slider.closest('.compare-product-model')?.querySelector('.product-info');


      function updateInfo(index) {
        var selected = flkty.cells[index].element;
        // console.log("productInfo",productInfo)
        // console.log("selected",selected);
        if (productInfo) {
          productInfo.innerHTML = selected.querySelector(".product_info_hidden").innerHTML;
        }
        
      }

      // Initial info
      updateInfo(flkty.selectedIndex);

      // On slide change
      flkty.on('change', updateInfo);
    });
  }

  // Frontend load
  document.addEventListener('DOMContentLoaded', () => initFlickitySlider());
  document.addEventListener('shopify:load', () => initFlickitySlider());
  document.addEventListener('shopify:section:load', e => initFlickitySlider(e.target));
  document.addEventListener('shopify:section:select', e => initFlickitySlider(e.target));


  
  function initTabVideoIfHave(sectionId) {
    let thresholdValue = 0;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.banner_video_wrapper');
    const isMobile = window.innerWidth <= 767;
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;
      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              playBtn?.classList.add('playing');
              // Don't hide poster yet — wait for "playing" event
            })
            .catch(() => {
              playBtn?.classList.remove('playing');
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo() {
        video.pause();
        playBtn?.classList.remove('playing');
        if (posterWrapper) posterWrapper.style.opacity = 1;
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if (video.closest('.ppblock')?.classList.contains('is-selected')) {
            autoplay = videoAutoplay ? true : false;
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } else if (window.Hls && Hls.isSupported()) {
            hls = new Hls({ maxBufferLength: 3 });
            hls.loadSource(src);
            hls.attachMedia(video);
            video.hlsInstance = hls;

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
              isVideoLoaded = true;
              if (autoplay) safePlay();
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.banner_video_wrapper');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          const activeTab = entry.target.closest('.tab-panel.active');
          //console.log("activeTab",activeTab)
          if (shouldPlay && activeTab) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          safePlay();
        } else {
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        const updateSoundControl = () => {
          const isMuted = video.muted;
          muteBtn.classList.toggle('muted', isMuted);
          muteBtn.setAttribute('aria-pressed', String(!isMuted));
          muteBtn.setAttribute('aria-label', isMuted ? 'Sl\u00e5 lyd til' : 'Sl\u00e5 lyd fra');
          muteBtn.textContent = isMuted ? '\uD83D\uDD0A Sl\u00e5 lyd til' : '\uD83D\uDD07 Sl\u00e5 lyd fra';
        };
        updateSoundControl();
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          video.dataset.userSoundEnabled = String(!video.muted);
          updateSoundControl();
        });
        muteBtn.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            muteBtn.click();
          }
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }
  function initTabbingSection(scope = document) {
    const sections = scope.querySelectorAll('.tabbing-section');
    console.log("sections---",sections)
    sections.forEach(section => {
      const sectionID = section.getAttribute('data-section-id');
      console.log("sectionID",sectionID)
      initTabVideoIfHave(sectionID);
      const buttons = section.querySelectorAll('.tab-buttons .tab-btn');
      const panels = section.querySelectorAll('.tab-panel');



      if (!buttons.length || !panels.length) return;

      buttons.forEach((btn, idx) => {
        btn.addEventListener('click', () => {
          document.body.classList.add('clicked-anywhere');
          // Remove active from all
          buttons.forEach(b => b.classList.remove('active'));
          panels.forEach(p => {
            p.classList.remove('active');
            const vid = p.querySelector('video');
            if (vid && !vid.paused) {
              vid.pause();
              vid.currentTime = 0;
            }
          });

          // Activate clicked
          btn.classList.add('active');
          panels[idx].classList.add('active');
          // Play video in active tab
          const video = panels[idx].querySelector('video');
          const muteBtn = panels[idx].querySelector('.glb_mute');

          if (video) {
            video.play().catch(() => {});
            if (document.body.classList.contains('clicked-anywhere')) {
                video.muted = false;
                muteBtn.classList.remove('muted');
              }
          }
        });
      });

      // Initialize HLS for videos
      section.querySelectorAll('.tab-video').forEach(video => {
        const source = video.querySelector('source')?.src;
        if (source && window.Hls && Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(source);
          hls.attachMedia(video);
        }
      });
    });
  }

// Shopify + Frontend Event Bindings
document.addEventListener('DOMContentLoaded', () => initTabbingSection());
document.addEventListener('shopify:section:load', e => initTabbingSection(e.target));
document.addEventListener('shopify:section:select', e => initTabbingSection(e.target));

document.addEventListener('DOMContentLoaded', () => initTabbingSectionPDP());
document.addEventListener('shopify:section:load', e => initTabbingSectionPDP(e.target));
document.addEventListener('shopify:section:select', e => initTabbingSectionPDP(e.target));

function initTabbingSectionPDP(scope = document) {
  const sections = scope.querySelectorAll('.productmainsec');
  sections.forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
  })
}
//STICKY ADD TO CART
document.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.getElementById('sticky-atc');
    const atcBtn = document.getElementById('sticky-atc-btn');
    const mainForm = document.querySelector('.product-form'); // adjust if your class is different
    const mainAtcBtn = mainForm?.querySelector('button[type="submit"]');
    const header = document.querySelector('header.theme__header');
    const footer = document.querySelector('footer .site-footer');
    const addtocartV = document.querySelector(".add-to-cart-variant");
  
    if (!stickyAtc || !mainForm || !mainAtcBtn) return;
  
    var HF = 0; //header.offsetHeight;
    function isElementOutOfView(el) {
      const rect = el.getBoundingClientRect();
      return rect.bottom < HF || rect.top > window.innerHeight;
    }
  
    function isFooterVisible() {
      const footerRect = footer.getBoundingClientRect();
      return footerRect.top < window.innerHeight;
    }
  
    function handleScroll() {
      if (isElementOutOfView(mainForm) && !isFooterVisible()) {
        stickyAtc.style.display = 'flex';
      } else {
        stickyAtc.style.display = 'none';
      }
    }
  
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll();
  
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    console.log("addtocartV",addtocartV)
    console.log("mainAtcBtn",mainAtcBtn)
    if (addtocartV && mainAtcBtn) {
      addtocartV.addEventListener('click', function () {
        console.log("sfsdf...")
        mainAtcBtn.click();
      });
    }

      
  });

// document.addEventListener('DOMContentLoaded', () => initCustomerVideoSection());
// document.addEventListener('shopify:section:load', e => initCustomerVideoSection(e.target));
// document.addEventListener('shopify:section:select', e => initCustomerVideoSection(e.target));


const header = document.querySelector('header'); // adjust selector
const headerHeight = header ? header.offsetHeight : 0;

document.querySelectorAll('ul.tab_relation li').forEach(li => {
  li.addEventListener('click', function () {
    const tabValue = this.getAttribute('data-tab');
    const targetTab = document.querySelector(`.tab-link-${tabValue}`);

    if (targetTab) {
      targetTab.click(); // trigger tab click
    }

    const productTabs = document.querySelector('.product-tabs');
    if (productTabs) {
      const topPos = productTabs.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: topPos,
        behavior: "smooth"
      });
    }
  });
});
document.querySelectorAll('.properties_block .buy_now').forEach(btn => {
  btn.addEventListener('click', function (e) {
    e.preventDefault();

    const target = document.querySelector('.info_and_form .form__wrapper');
    if (target) {
      const topPos = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: topPos,
        behavior: 'smooth'
      });
    }
  });
});

document.querySelectorAll(".init_hls_video_player").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
          console.log("dfff----",sectionID)

    initCustomVideoPlayerWithHLS(sectionID);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".init_hls_video_player");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomVideoPlayerWithHLS(sectionID);
    }
  });

// document.querySelectorAll('.radio-switch').forEach(function(switchEl) {
//   switchEl.addEventListener('change', function (e) {
//     if (e.target.matches('input[type="radio"]')) {
//       if (e.target.value === 'with_vat') {
//         console.log("Med moms selected for:", switchEl);
//         // 👉 update incl. VAT price inside this switchEl's product container
//       } else if (e.target.value === 'without_vat') {
//         console.log("Uden moms selected for:", switchEl);
//         // 👉 update excl. VAT price inside this switchEl's product container
//       }
//     }
//   });
// });



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
